export const css = {
    root: '_3gE0RZen',
    secondary: '_3_gpyTNk',
    required: '_2hISeaXa',
    ' _key': 'certwise-theme/certwise/dojo/label'
};
export default css;
